import { useBadgingTranslation } from '../../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Divider, Typography } from '@mui/material';
import React from 'react';
export const BadgeDetailsPageHeaderAnalytics = ({ badge }) => {
    const { t } = useBadgingTranslation();
    return (React.createElement(Box, { sx: {
            display: 'flex',
            gap: 2,
        } },
        React.createElement(Box, { sx: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 1,
                backgroundColor: themeColors.alphaLightSurface.base,
                borderWidth: 1,
                borderStyle: 'solid',
                borderColor: themeColors.alphaLightSurface.subtlest,
                p: 1.5,
                gap: 0.5,
                flexBasis: 'calc(25% - 4px)',
            } },
            React.createElement(Typography, { variant: 'h6' }, badge.validAccountBadgesCount),
            React.createElement(Typography, { variant: 'body2' }, t('badges.badgeDetails.analytics.valid'))),
        React.createElement(Box, { sx: {
                display: 'flex',
                borderRadius: 1,
                backgroundColor: themeColors.alphaLightSurface.base,
                borderWidth: 1,
                borderStyle: 'solid',
                borderColor: themeColors.alphaLightSurface.subtlest,
                p: 1.5,
                gap: 2,
                flexBasis: 'calc(75% - 4px)',
            } },
            React.createElement(Box, { sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 0.5,
                    flexBasis: {
                        xs: '25%',
                        sm: '33%',
                    },
                } },
                React.createElement(Typography, { variant: 'h6' }, badge.invalidAccountBadgesCount),
                React.createElement(Typography, { variant: 'body2' }, t('badges.badgeDetails.analytics.invalid'))),
            React.createElement(Divider, { orientation: 'vertical', flexItem: true, color: themeColors.decorative.white, sx: { opacity: 0.27 } }),
            React.createElement(Box, { sx: {
                    display: 'flex',
                    width: '100%',
                    flexDirection: {
                        xs: 'column',
                        md: 'row',
                    },
                    flexWrap: 'wrap',
                    justifyContent: {
                        xs: 'space-between',
                        md: 'start',
                    },
                    gap: { xs: 1, md: 0 },
                } },
                React.createElement(Typography, { variant: 'body2', sx: {
                        flexBasis: {
                            md: '50%',
                        },
                    } },
                    badge.expiredAccountBadgesCount,
                    " ",
                    t('badges.badgeDetails.analytics.expired')),
                React.createElement(Typography, { variant: 'body2', sx: {
                        flexBasis: {
                            md: '50%',
                        },
                    } },
                    badge.revokedAccountBadgesCount,
                    " ",
                    t('badges.badgeDetails.analytics.revoked')),
                React.createElement(Typography, { variant: 'body2', sx: {
                        flexBasis: {
                            md: '50%',
                        },
                    } },
                    badge.reissueNeededAccountBadgesCount,
                    " ",
                    t('badges.badgeDetails.analytics.reissueNeeded'))))));
};
